import React from "react";
import { Link } from "react-router-dom";
import supportImg from "../../assets/support.webp";
import {
  ArrowDown,
  Mail,
  Sparkles,
} from "lucide-react";

function ContactHero() {
  return (
    <section className="relative overflow-hidden bg-[#f7faf8] pt-5 pb-12 sm:pt-8 sm:pb-16 lg:pt-10 lg:pb-20">
      {/* Soft Ambient Background Radial Glows */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_12%_35%,rgba(46,229,162,0.12),transparent_40%),radial-gradient(circle_at_88%_45%,rgba(0,135,81,0.08),transparent_40%)]"
      />

      <div className="section-container relative z-10">
        
        {/* ================= 1. BREADCRUMB ================= */}
        <nav className="flex items-center gap-2 font-jakarta text-[12.5px] sm:text-[13px] text-[#6b7280] mb-5 sm:mb-8">
          <Link
            to="/"
            className="hover:text-[var(--hero-green)] transition-colors"
          >
            Home
          </Link>
          <span className="text-[#9ca3af]">›</span>
          <span className="font-semibold text-[#111827]">
            Contact Us
          </span>
        </nav>

        {/* ================= 2. CLEAN 2-COLUMN FULLY RESPONSIVE GRID ================= */}
        <div className="grid grid-cols-1 items-center gap-8 sm:gap-10 lg:grid-cols-12 lg:gap-10 xl:gap-14">
          
          {/* LEFT COLUMN: Narrative, Headline, Subtitle & Action Buttons */}
          <div className="lg:col-span-6 xl:col-span-6">
            
            {/* Tag Badge */}
            <span className="inline-flex items-center gap-1.5 rounded-full bg-[var(--hero-green-light)] px-3 py-1 font-jakarta text-[11.5px] sm:text-[12px] font-bold text-[var(--hero-green)] border border-[var(--hero-green-border)] shadow-xs mb-3.5 sm:mb-4">
              <Sparkles size={13} className="text-[var(--hero-green)]" />
              <span>DIRECT SUPPORT & PARTNERSHIP DESK</span>
            </span>

            {/* Main Headline */}
            <h1 className="font-syne text-[28px] sm:text-[38px] md:text-[46px] lg:text-[54px] xl:text-[60px] font-bold leading-[1.15] tracking-[-0.5px] sm:tracking-[-1.5px] text-[#111827] text-balance">
              We&apos;re Here to Accelerate <span className="text-[var(--hero-green)]">Your Financial Growth.</span>
            </h1>

            {/* Sub-headline */}
            <p className="mt-4 sm:mt-5 max-w-[580px] font-jakarta text-[15px] sm:text-[16.5px] lg:text-[17px] leading-[1.65] text-[#556369]">
              Have a query about DSA onboarding, loan clearance, lender integration,
              or customized ticket sizing? Our relationship teams respond within 1 working hour.
            </p>

            {/* Action Buttons */}
            <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
              <a
                href="#contact-form"
                className="inline-flex h-[48px] sm:h-[50px] items-center justify-center gap-2.5 rounded-full bg-[var(--hero-green)] px-7 sm:px-8 font-jakarta text-[14.5px] sm:text-[15px] font-bold text-white shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:bg-[var(--hero-green-hover)] hover:shadow-lg outline-none focus:outline-none cursor-pointer"
              >
                <span>Send Us a Message</span>
                <ArrowDown size={16} strokeWidth={2.4} />
              </a>

              <a
                href="mailto:supportfinserv@gmail.com"
                className="inline-flex h-[48px] sm:h-[50px] items-center justify-center gap-2 rounded-full border border-[#d6e2db] bg-white px-6 sm:px-7 font-jakarta text-[14.5px] sm:text-[15px] font-bold text-[#111827] shadow-2xs transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#f3f7f5] hover:border-[#cbdad1] outline-none focus:outline-none cursor-pointer"
              >
                <Mail size={16} className="text-[var(--hero-green)]" />
                <span>supportfinserv@gmail.com</span>
              </a>
            </div>

          </div>

          {/* RIGHT COLUMN: Natural Seamless Floating Support Representative Image */}
          <div className="lg:col-span-6 xl:col-span-6 flex items-center justify-center pt-2 lg:pt-0">
            <div className="relative flex items-center justify-center w-full max-w-[480px] sm:max-w-[540px] lg:max-w-[580px] xl:max-w-[620px]">
              
              {/* Soft Ambient Mint Glow Halo */}
              <div
                aria-hidden="true"
                className="pointer-events-none absolute h-[260px] w-[260px] sm:h-[320px] sm:w-[320px] lg:h-[380px] lg:w-[380px] rounded-full bg-[radial-gradient(circle,rgba(46,229,162,0.35),transparent_70%)] blur-3xl"
              />

              {/* Natural Seamless Cutout Image */}
              <img
                src={supportImg}
                alt="Finverse Dedicated Customer & DSA Support"
                className="relative z-10 w-full h-auto max-h-[360px] sm:max-h-[440px] lg:max-h-[500px] object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.1)] transition-transform duration-300 hover:scale-[1.02]"
                loading="eager"
              />
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default ContactHero;
